// eslint-disable-next-line import-x/no-unresolved
import { useRegisterSW } from 'virtual:pwa-register/react';

import { ErrorSeverity, handleError } from 'services/errorService';

function RegisterSW() {
  const { updateServiceWorker } = useRegisterSW({
    async onNeedRefresh() {
      try {
        await updateServiceWorker(true);
      } catch (error) {
        handleError(error, ErrorSeverity.INFO, {
          source: 'RegisterSW',
          operation: 'updating service worker',
        });
      }
    },
  });

  return <></>;
}

export default RegisterSW;
